import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import LabelChip from '@/views/shared/LabelChip.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(LabelChip.name, LabelChip)
